import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { deleteAgentSession, fetchAgentSessions } from '../api/agent.api'

const SESSIONS_QUERY_KEY = ['agent', 'sessions'] as const

export function useAgentSessions(enabled = false) {
  const queryClient = useQueryClient()

  const sessionsQuery = useQuery({
    queryKey: SESSIONS_QUERY_KEY,
    queryFn: fetchAgentSessions,
    enabled,
  })

  const deleteMutation = useMutation({
    mutationFn: deleteAgentSession,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SESSIONS_QUERY_KEY })
    },
  })

  const invalidateSessions = () => {
    queryClient.invalidateQueries({ queryKey: SESSIONS_QUERY_KEY })
  }

  return {
    sessions: sessionsQuery.data ?? [],
    isLoading: sessionsQuery.isLoading,
    deleteSession: deleteMutation.mutate,
    invalidateSessions,
  }
}
